import { render } from "./B2bHero.vue?vue&type=template&id=c5785198&ts=true"
import script from "./B2bHero.vue?vue&type=script&lang=ts"
export * from "./B2bHero.vue?vue&type=script&lang=ts"

import "./B2bHero.vue?vue&type=style&index=0&id=c5785198&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__